import packageJson from '../package.json';

export const FEATURE_BOARD_SCRIPT_ID = 'featureboard-embed-script';
export const FEATURE_BOARD_SCRIPT_SRC = 'https://simplefeatureboard.com/embed.js';

export function initializeFeatureBoard() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  window.FeatureBoardConfig = {
    projectKey: 'pk_fb_c6f1zPjDPhQhSS3wKsFAWfXTVTNGXJux',
    accentColor: '#2F8CBB',
    buttonLabel: 'Feature Request',
    context: {
      appVersion: packageJson.version,
    },
  };

  const existingScript =
    document.getElementById(FEATURE_BOARD_SCRIPT_ID) ||
    document.querySelector(`script[src="${FEATURE_BOARD_SCRIPT_SRC}"]`);

  if (existingScript) {
    return;
  }

  const script = document.createElement('script');
  script.id = FEATURE_BOARD_SCRIPT_ID;
  script.src = FEATURE_BOARD_SCRIPT_SRC;
  script.async = true;
  document.head.appendChild(script);
}
